import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { adoptPet } from "../../redux/action-creators/adoptPetAction";
import { Grid } from "@mui/material";
import { Button, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { toast } from "../../utils/toastsMessage";
import { RoutingLinks } from "../../utils/constants";
import {otherText} from "../../utils/helper";
// import { adoptPet } from "../../redux/action-creators/adoptPetAction";
import { RouteComponentProps, useHistory } from "react-router-dom";
import { getdatabyId } from "../../redux/action-creators/adoptionAction";
import LeftSidebar from "../../components/sidebars/LeftSidebar";
import ProductSidebar from "../../components/sidebars/ProductSidebar";
import { ProductStyles } from "../products/ProductsStyle";
import { UserCommonStyles } from "../../styles/CommonStyles";
import { Type } from "../../utils/constants";
import SocialIconSection from "../../components/sidebars/SocialIconSection";
import { capitalize } from "../../utils/helper";

const AdoptionDetail = (props: RouteComponentProps) => {
  const { t: translation } = useTranslation();
  const history = useHistory();
  const commonStyle = UserCommonStyles();
  const styleClasses = ProductStyles();
  const dispatch = useDispatch();
  const [Images, setImages] = useState([]);
  const type = Type.adoption;
  const [open, setOpen] = useState(false);
  const { id }: { id: string } = useParams();
  const userId = localStorage.getItem("userId");
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#fff",
    outline: "none !important",
    boxShadow: 24,
    p: 4,
  };
  const {
    handleSubmit,
    reset,
    register,
    control,
    formState: { errors },
  } = useForm();

  /**
 * Function To get the details of Pets
 * @param id
 */

  const [post_id, setPostId] = useState('');
  const [adopt_status, setAdoptStatus] = useState();
  const [repeat, setRepeat] = useState(false);
  const [loader, setLoader] = useState(false);
  const [adoptionDetail, setAdoptionDetail] = useState([]);

  const Adopt = async () => {
    if (id) {
      const formData = {
        postId: parseInt(id),
        adoptionerId: Number(userId),
        userId: adoptionDetail[0]?.userId
      };
      const response: any = await dispatch(adoptPet({ formData }));
 
      if (response?.data?.statusCode === 201) {
        // setOpen(true)
        toast.success("Your adoption request has been sent.")
      } else {
        return toast.info(response.message);
      };
    };
  };

  const OrderConfirmed = () => {
    setRepeat(true);
    setOpen(false);
  };

  const petDetails = useCallback(async (id: string) => {
    setLoader(true);
    const result: any = await dispatch(getdatabyId(id, type));
    const response = result?.data?.data;
    if (response && response.length) {
      setAdoptionDetail(response);
      let data = response[0]?.image;
      data = JSON.parse(data);
      setImages(data);
    }
    setLoader(false);
  }, [dispatch, type]);

  useEffect(() => {
    petDetails(id);
  }, [id, petDetails, repeat]);
  
  return (
    <Box>
      <Box className={commonStyle.windowColor}>
        <Grid container>
          <Grid item md={3}>
            <LeftSidebar />
            {/* <SocialIconSection /> */}
          </Grid>

          <Grid item md={6}>
            {adoptionDetail.length > 0 ? (
              <Box className={`${commonStyle.p20} ${commonStyle.mt20}`}>
                <Box
                  className={`${commonStyle.bgWhite} ${styleClasses.combineBox}`}
                >
                  <Box
                    className={`${commonStyle.p20} ${commonStyle.card} ${styleClasses.productDetailCard}`}
                  >
                    <img
                      src={Images[0] ? Images[0] : null}
                      alt={translation("imgalt_product")}
                      className={styleClasses.productCardImg}
                    />
                  </Box>

                  <Grid container spacing={2} className={commonStyle.mt10}>
                    {Images.length > 0 &&
                      Images.slice(1).map((item, index) => (
                        <Grid key={index} item lg={4}>
                          <Box
                            className={`${commonStyle.flexCenter} ${commonStyle.card} ${styleClasses.productDetailCard}`}
                          >
                            <img src={item} alt={translation("imgalt_product")} />
                          </Box>
                        </Grid>
                      ))}
                  </Grid>
                  {userId && userId != adoptionDetail[0]?.userId && adoptionDetail[0]?.status === "0" ? (
                    <Box className={`${commonStyle.justifyCenter} ${commonStyle.dflex}`}>
                      <button onClick={handleSubmit(Adopt)} style={{ border: "none" }} className={`
                    ${commonStyle.mt10} 
                    ${commonStyle.bgSkyBlue} 
                    ${commonStyle.btnWidth} 
                    ${commonStyle.white} 
                    ${commonStyle.py10} 
                    ${commonStyle.weightLight} 
                    ${commonStyle.borderRad8} 
                    ${commonStyle.font16} 
                    `}>
                        {"I want to adopt"}
                      </button>

                      {/* // This Modal is not in use  */}
                      <Modal
                        open={open}
                        onClose={OrderConfirmed}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={style}>
                          <Typography
                            id="modal-modal-title"
                            variant="h5"
                            className={`${commonStyle.textCenter} ${commonStyle.bold1} ${commonStyle.mt20}`}
                          >
                            {translation("Congratulations")}
                          </Typography>
                          <Box className={commonStyle.py15}>
                            <Box className={`${commonStyle.textCenter}`} >
                              <Typography>
                                You have adopted this pet.
                              </Typography>
                            </Box>

                            <Box
                              className={`
                        ${commonStyle.blueBtn} 
                        ${commonStyle.py15} 
                        ${commonStyle.textCenter} 
                        ${commonStyle.mt10}`}
                            >
                              <Button
                                className={`${commonStyle.btnpy1060}`}
                                onClick={OrderConfirmed}
                              // disabled={showConfirmButton}
                              >
                                {translation("OK")}
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      </Modal>
                    </Box>
                  ) : userId && userId == adoptionDetail[0]?.userId ? (
                    <Box className={`${commonStyle.justifyCenter} ${commonStyle.dflex}`}>
                      <button
                        onClick={() => history.push(`${RoutingLinks.adoptionRequest}${id}`)}
                        // onClick={() => }
                        style={{ border: "none" }}
                        className={`
                    ${commonStyle.mt10} 
                    ${commonStyle.bgSkyBlue} 
                    ${commonStyle.btnWidth} 
                    ${commonStyle.white} 
                    ${commonStyle.py10} 
                    ${commonStyle.weightLight} 
                    ${commonStyle.borderRad8} 
                    ${commonStyle.font16} 
                    `}>
                        {"Adoption Requests"}
                      </button>
                    </Box>
                  ) : null}
                </Box>
              </Box>
            ) : loader ? otherText("Loading...") : otherText("No Data Found")}

          </Grid>
          <Grid item md={3}>
            <ProductSidebar id={id} type={type} userList={adoptionDetail} foundUser={[]} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default AdoptionDetail;
